export const TASK_LIST_PAGE_SIZE = 20;
export const TASK_BOARD_PAGE_SIZE = 100;

export const TASK_BOARD_STATUSES = [
    { name: 'open', label: 'Open', type: 'open', color: '#808080' },
    { name: 'To Do', label: 'To Do', type: 'open', color: '#808080' },
    { name: 'In Progress', label: 'In Progress', type: 'in_progress', color: '#3498db' },
    { name: 'Review', label: 'Review', type: 'in_progress', color: '#f39c12' },
    { name: 'Done', label: 'Done', type: 'completed', color: '#2ecc71' }
];

export const buildTaskListRequest = ({
    rootUrl,
    projectId,
    scope,
    status,
    priority,
    search = '',
    sort = 'created_desc',
    limit = TASK_LIST_PAGE_SIZE,
    offset = 0,
}) => {
    const url = projectId
        ? `${rootUrl}/api/tasks/project/${projectId}`
        : `${rootUrl}/api/tasks`;

    return {
        url,
        params: {
            scope,
            status: status !== 'all' ? status : undefined,
            priority: priority !== 'all' ? priority : undefined,
            search: search || undefined,
            sort,
            limit,
            offset,
        },
    };
};

export const buildTaskBoardRequest = ({
    rootUrl,
    scope = 'all',
    status = 'all',
    priority = 'all',
    search = '',
    sort = 'created_desc',
    limit = TASK_BOARD_PAGE_SIZE,
    offset = 0,
}) => ({
    url: `${rootUrl}/api/tasks/user/current`,
    params: {
        scope,
        status: status !== 'all' ? status : undefined,
        priority: priority !== 'all' ? priority : undefined,
        search: search || undefined,
        sort,
        limit,
        offset,
    },
});

export const mergeTaskChunks = (currentTasks, newTasks) => {
    const byId = new Map();

    [...currentTasks, ...newTasks].forEach((task) => {
        if (task && task.id != null) {
            byId.set(task.id, task);
        }
    });

    return Array.from(byId.values());
};
